import apiService from './api.service';

class QuickMenuService {
  async getQuickMenuDocuments(categoryId = 54) {
    try {
      const response = await apiService.post('/info/by-category', { CategoryId: categoryId }, {}, true);

      if (response && response.code === 1 && Array.isArray(response.data)) {
        const documents = response.data
          .filter(item => item.IsPublished && !item.IsDeleted)
          .sort((a, b) => (a.SortOrder || 0) - (b.SortOrder || 0))
          .map(item => ({
            infoId: item.InfoId,
            title: item.Title || item.SubTitle || '',
            subtitle: item.SubTitle || '',
            link: item.Link || '',
            sortOrder: item.SortOrder || 0,
          }));

        return {
          success: true,
          data: documents,
          message: response.message,
        };
      }

      return {
        success: false,
        data: [],
        message: response?.message || 'No quick menu documents found',
      };
    } catch (error) {
      return {
        success: false,
        data: [],
        message: error.message || 'An error occurred while fetching quick menu documents',
      };
    }
  }
}

export default new QuickMenuService();
